/* Bundle tier selector. Adds the chosen quantity of the currently selected
   variant. It never invents a price: the button shows the arithmetic the tiers
   advertise, and the cart applies whatever real automatic discount exists. If
   the two disagree, the discount is missing and the block should be switched
   off, not patched here. */
class AnyraBundle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-anyra-bundle-add]');
    this.label = this.querySelector('[data-anyra-bundle-label]');
    this.msg = this.querySelector('[data-anyra-bundle-msg]');
    this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    this.format = this.dataset.currencyFormat || 'Rs {{amount}}';
    this.baseLabel = this.label ? this.label.textContent.trim() : 'Add to cart';

    this.driveMain = this.dataset.driveMain === 'true';

    this.radios.forEach((r) => r.addEventListener('change', () => this.sync()));
    this.button?.addEventListener('click', () => this.add());
    this.sync();
  }

  get selected() {
    return this.radios.find((r) => r.checked) || this.radios[0];
  }

  money(cents) {
    return this.format.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2, maximumFractionDigits: 2,
    }));
  }

  get mainForm() {
    return document.getElementById(this.dataset.form)
      || document.querySelector('form[action*="/cart/add"]');
  }

  sync() {
    const r = this.selected;
    if (!r) return;

    if (this.label) {
      this.label.textContent = `${this.baseLabel} - ${this.money(parseInt(r.dataset.net, 10))}`;
    }

    if (!this.driveMain) return;

    // Push the chosen quantity onto the page's own product form and let its
    // Add to cart do the work. Dispatch both events so the theme's quantity
    // component and any listener stay in step with the number shown.
    const qty = this.mainForm?.querySelector('input[name="quantity"]');
    if (qty && qty.value !== r.dataset.qty) {
      qty.value = r.dataset.qty;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  variantId() {
    // Read the live variant off the real product form so a variant change here
    // cannot drift from the one the shopper picked.
    const form = document.getElementById(this.dataset.form)
      || document.querySelector('form[action*="/cart/add"]');
    return form?.querySelector('[name="id"]')?.value || null;
  }

  say(text, isError) {
    if (!this.msg) return;
    this.msg.textContent = text;
    this.msg.hidden = !text;
    this.msg.classList.toggle('anyra-bundle__msg--error', !!isError);
  }

  async add() {
    const id = this.variantId();
    const qty = parseInt(this.selected?.dataset.qty || '1', 10);
    if (!id) { this.say('Could not read the selected variant. Please refresh.', true); return; }

    this.button.setAttribute('aria-busy', 'true');
    this.button.disabled = true;
    this.say('');

    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'That could not be added to the cart.');
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      this.say('Added to your cart.');
    } catch (e) {
      this.say(e.message, true);
    } finally {
      this.button.removeAttribute('aria-busy');
      this.button.disabled = false;
    }
  }
}
customElements.define('anyra-bundle', AnyraBundle);
